// extracted by mini-css-extract-plugin
export default {"backgroundColor":"#fdfdfd","wrapper":"Tooltip-module__wrapper--ef32a"};